import script from "./TextWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TextWidget.vue?vue&type=script&setup=true&lang=js"

import "./TextWidget.vue?vue&type=style&index=0&id=49d52307&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d52307"]])

export default __exports__